import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUserShield, 
  faEnvelope, 
  faCalendar,
  faCheckCircle,
  faTimesCircle,
  faShieldAlt
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import AdminChangePassword from '../../components/AdminChangePassword';
import './admin.css';

const AdminProfile = () => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    // Get admin info from localStorage
    const adminUser = JSON.parse(localStorage.getItem('admin_user') || '{}');
    setAdmin(adminUser);
  }, []);

  if (!admin || !admin.username) {
    return (
      <div className="admin-loading">
        <p>Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="admin-content">
      <div className="admin-header">
        <div>
          <h1>
            <FontAwesomeIcon icon={faUserShield} /> My Profile
          </h1>
          <p>Manage your administrator account</p>
        </div>
      </div>

      <div style={{ maxWidth: '800px' }}>
        {/* Profile Information Card */}
        <div style={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #333',
          borderRadius: '12px',
          padding: '2rem',
          marginBottom: '2rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'start', marginBottom: '2rem' }}>
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              backgroundColor: '#FFB6C1',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '2rem'
            }}>
              <FontAwesomeIcon icon={faUserShield} size="3x" color="#000" />
            </div>
            <div style={{ flex: 1 }}>
              <h2 style={{ marginBottom: '0.5rem', color: '#fff' }}>{admin.full_name}</h2>
              <p style={{ color: '#999', marginBottom: '0.5rem' }}>
                <FontAwesomeIcon icon={faEnvelope} /> {admin.email}
              </p>
              <div style={{
                display: 'inline-block',
                backgroundColor: admin.is_active ? '#4ade80' : '#ef4444',
                color: '#000',
                padding: '0.25rem 0.75rem',
                borderRadius: '4px',
                fontSize: '0.85rem',
                fontWeight: '600'
              }}>
                <FontAwesomeIcon icon={admin.is_active ? faCheckCircle : faTimesCircle} />
                {' '}
                {admin.is_active ? 'Active' : 'Inactive'}
              </div>
            </div>
          </div>

          <div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              padding: '1rem 0', 
              borderBottom: '1px solid #333' 
            }}>
              <span style={{ color: '#999' }}>Username:</span>
              <span style={{ color: '#fff' }}>{admin.username}</span>
            </div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              padding: '1rem 0', 
              borderBottom: '1px solid #333' 
            }}>
              <span style={{ color: '#999' }}>Role:</span>
              <span style={{ color: '#fff' }}>{admin.role || 'Super Admin'}</span>
            </div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              padding: '1rem 0', 
              borderBottom: '1px solid #333' 
            }}>
              <span style={{ color: '#999' }}>Created:</span>
              <span style={{ color: '#fff' }}>
                {admin.created_at 
                  ? new Date(admin.created_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })
                  : 'N/A'
                }
              </span>
            </div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              padding: '1rem 0' 
            }}>
              <span style={{ color: '#999' }}>Last Login:</span>
              <span style={{ color: '#fff' }}>
                {admin.last_login 
                  ? new Date(admin.last_login).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  : 'N/A'
                }
              </span>
            </div>
          </div>
        </div>

        {/* Password Change Section */}
        <AdminChangePassword />

        {/* Security Notice */}
        <div style={{
          backgroundColor: '#0a0a0a',
          border: '1px solid #FFB6C1',
          borderRadius: '12px',
          padding: '1.5rem',
          marginTop: '2rem'
        }}>
          <h3 style={{ 
            color: '#FFB6C1', 
            marginBottom: '0.75rem',
            fontSize: '1rem'
          }}>
            <FontAwesomeIcon icon={faShieldAlt} /> Security Best Practices
          </h3>
          <ul style={{ 
            color: '#999', 
            paddingLeft: '1.5rem', 
            margin: '0',
            fontSize: '0.9rem',
            lineHeight: '1.6'
          }}>
            <li style={{ marginBottom: '0.5rem' }}>
              Change your password regularly (at least every 90 days)
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Never share your administrator credentials
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Use a unique password that's different from other accounts
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Monitor audit logs for any suspicious activity
            </li>
            <li>
              Log out when you're finished with administrative tasks
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
